import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";

export type ProfileVerifyingConfirmVariant = "purchase" | "content";

function getStoreUser(): User | null {
  // Lazy import avoids circular dependency: store → actions → payments → guard → store
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  return require("@/store").default.state.user;
}

export function isPurchaseBlockedByAgeVerification(user: User | null | undefined): boolean {
  if (!user) return false;
  return user.ageVerification?.status !== UserVerificationStatus.VERIFIED;
}

export function showProfileVerifyingConfirm(variant: ProfileVerifyingConfirmVariant = "purchase") {
  emitter.emit(EVENTS.SHOW_PROFILE_VERIFYING_CONFIRM, { variant });
}

export function blockPurchaseIfAgeNotVerified(user?: User | null): boolean {
  const targetUser = user === undefined ? getStoreUser() : user;
  if (!isPurchaseBlockedByAgeVerification(targetUser)) {
    return false;
  }
  showProfileVerifyingConfirm("purchase");
  return true;
}
